import { BaseContainerModel } from '../../base-container.model';
import  {bl_fi_mst_warranty_price_matrix_RowClass } from '../../../dbschema';

export class WarrantyPriceMatrixContainerModel extends BaseContainerModel {

  bl_fi_mst_warranty_price_matrix: bl_fi_mst_warranty_price_matrix_RowClass = new bl_fi_mst_warranty_price_matrix_RowClass();
}
